import { lazy } from "react";
import { PATHS } from "@/lib/router";

const GElementPage = lazy(() => import("./pages/GElementPage"));

export const gElementRoutes = [
  {
    path: PATHS.G_Element,
    element: <GElementPage />,
  },
];
